import fetcher from '../_generic/fetcher.fn.js';
import Form from '../_generic/lib/Form.class.js';
import FinalSelect from './lib/FinalSelect.class.js';
import FinalBox from './lib/FinalBox.class.js';
import Tabs from './lib/Tabs.class.js';

import rezone from './helpers/rezone.fn.js';
import init_tel_mask from './helpers/init_tel_mask.fn.js';

import FinalCarousel from './lib/FinalCarousel.class.js';
import finalCarouselArrows from './lib/FinalCarousel/arrows.fn.js';
import finalCarouselPointerInteraction from './lib/FinalCarousel/pointer_interaction.fn.js';
FinalCarousel.addPlugins( finalCarouselArrows );
FinalCarousel.addPlugins( finalCarouselPointerInteraction );


import.meta.glob(
	['./handlers/**',], 
	{eager: true}
);


// Triggering when DOM ready
document.addEventListener('DOMContentLoaded', () => {
	[...document.querySelectorAll('select')].map((s) => new FinalSelect(s) );
});


// Triggering when everything loaded
window.addEventListener('load', () => {

	[ ...document.querySelectorAll('input[type="tel"]') ].map((input) => {

		init_tel_mask(input);

	});


	// The post-loaders
	[...document.querySelectorAll('[data-load]')].map(( el ) => {
		fetcher(el.getAttribute('data-load'), null, null, el);
	});

	// The FinalBox postprocess content
	document.addEventListener('finalbox_open_start', (e) => {

		[... e.detail[0][0].querySelectorAll('form') ].map((form) => {

			if( form  ){
				new Form( form );
				[...form.querySelectorAll('select')].map((s) => new FinalSelect(s));
			}


		});

		[... e.detail[0][0].querySelectorAll('input[type="tel"]')].map((input) => init_tel_mask(input));

		[... e.detail[0][0].querySelectorAll('[data-date]')].map((el) => rezone(el));

	});

	// Leaderboard expansion
	document.querySelector('.leaderboard')?.addEventListener('click',(e) => {
		if( e.target.classList.contains('leaderboard') )
			return;

		if( [...e.target.parentNode.children].indexOf(e.target) <= 1 )
			e.target.parentNode.classList.toggle('expanded');

	});

	// Carousels
	[ ... document.querySelectorAll('.carousel > .viewport') ].map((vp) => {
		new FinalCarousel(vp);
	});

	// Dropdowns
	[...document.querySelectorAll('.dropdown')].map((dd) => {
		dd.addEventListener('click', ( e1 ) => {
			dd.classList.toggle('active');

			if( dd.classList.contains('active') ){

				document.addEventListener('click', { handleEvent: function(e2){

					if( e1 != e2 ){					
						dd.classList.remove('active');
						document.removeEventListener('click', this);
					}
				}});


			}
		});
	});

	// Notifications
	let notifications = document.querySelector('#notifications');
	if( notifications ) new FinalBox( notifications );

	let notifications_noclose = document.querySelector('#notifications_noclose');
	if( notifications_noclose ) new FinalBox( notifications_noclose, {close: false} );

	// Tabs
	[...document.querySelectorAll('.tabs')].map((t) => new Tabs(t));

	// Dates
	[...document.querySelectorAll('[data-date]')].map((el) => {
		rezone( el );
	});


})
